import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  Box,
  FormControl,
  Select,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
// components
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
import { UserListToolbar } from '../sections/@dashboard/user';
// mock
import {
  getDeletedCustomProductOrderMethod,
  getCustomProductOrderCancelledMethod,
  getCustomProductOrderCompleteMethod,
  getCustomProductOrderConfirmMethod,
  getCustomProductOrderDeliverMethod,
  getCustomProductOrderMethod,
  getCustomProductOrderPendingMethod,
} from '../redux/slice/customProductOrdersSlice';
import CustomProductOrdersService from '../redux/api/CustomProductOrdersService';
import DeliveryChargesDialog from '../components/Dialog/DeliveryChargesDialog';
import OrderProductListHead from '../sections/@dashboard/user/OrderProductListHead';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'name', label: ' Customer Name', alignRight: false },
  { id: 'phone', label: 'Customer Phone', alignRight: false },
  { id: 'delivery_address', label: 'Delivery Address', alignRight: false },
  { id: 'customQuantity', label: 'Total Quantity', alignRight: false },
  { id: 'customTotal', label: 'Total Price', alignRight: false },
  { id: 'total_shipping_fee', label: 'Shipping Fee', alignRight: false },
  { id: 'payment_method', label: 'Payment Method', alignRight: false },
  { id: 'createdAt', label: 'Date', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: 'ChangeStatus', label: 'Change Status', alignRight: false },
  { id: '' },
];
// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function CustomProductOrderPage() {
  const dispatch = useDispatch();

  const [open, setOpen] = useState(null);

  const [orderId, setOrderId] = useState(null);

  const [orderItem, setOrderItem] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [requestName, setRequestName] = useState('All');

  const [changeStatusMenu, setChangeStatusMenu] = useState(false);

  const [deliveryDiloag, setDeliveryDiloag] = useState(false);

  const handleDelivery = () => {
    setDeliveryDiloag(!deliveryDiloag);
  };

  const [selectStatus, setSelectStatus] = useState('Change Status');

  const [orderStatus, setorderStatus] = useState(null);

  const data = useSelector((state) => state.customProductOrders);

  useEffect(() => {
    if (requestName === 'All') {
      dispatch(getCustomProductOrderMethod());
    } else if (requestName === 'Pending') {
      dispatch(getCustomProductOrderPendingMethod());
    } else if (requestName === 'Confirm') {
      dispatch(getCustomProductOrderConfirmMethod());
    } else if (requestName === 'Completed') {
      dispatch(getCustomProductOrderCompleteMethod());
    } else if (requestName === 'Cancelled') {
      dispatch(getCustomProductOrderCancelledMethod());
    } else if (requestName === 'Deliver') {
      dispatch(getCustomProductOrderDeliverMethod());
    } else {
      dispatch(getDeletedCustomProductOrderMethod());
    }
  }, [requestName,dispatch]);

  const handleOpenMenu = (event, row) => {
    setOrderId(row._id);
    setOrderItem(row);
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const handleOpenChangeStatusMenu = (event, id) => {
    setChangeStatusMenu(event.currentTarget);
    setOrderId(id);
  };
  const handleCloseChangeStatusMenu = () => {
    setChangeStatusMenu(false);
  };

  const filteredUsers = applySortFilter(
    data.data !== null && data.data !== undefined ? data.data : [],
    getComparator(order, orderBy),
    filterName
  );
  const emptyRows = rowsPerPage - Math.min(rowsPerPage, filteredUsers.length - page * rowsPerPage);

  const isNotFound = !filteredUsers.length && !!filterName;

  const handleDeleteMethod = async () => {
    if (requestName === 'Deleted') {
      await CustomProductOrdersService.premanentDelete(orderId)
        .then((res) => {
          console.warn('--------', res);
          toast.success('Order deleted successfully');
          dispatch(getDeletedCustomProductOrderMethod());
          setOrderId(null);
          setOpen(false);
        })
        .catch((error) => {
          if (!error.response.data.message) {
            toast.error(error.message, { position: 'top-right' });
          } else {
            toast.error(error.response.data.message, { position: 'top-right' });
          }
        });
    } else {
      await CustomProductOrdersService.softDelete(orderId)
        .then((res) => {
          console.warn('--------', res);
          toast.success(res?.data?.message);
          if (requestName === 'All') {
            dispatch(getCustomProductOrderMethod());
          } else if (requestName === 'Pending') {
            dispatch(getCustomProductOrderPendingMethod());
          } else if (requestName === 'Confirm') {
            dispatch(getCustomProductOrderConfirmMethod());
          } else if (requestName === 'Completed') {
            dispatch(getCustomProductOrderCompleteMethod());
          } else if (requestName === 'Cancelled') {
            dispatch(getCustomProductOrderCancelledMethod());
          } else if (requestName === 'Deliver') {
            dispatch(getCustomProductOrderDeliverMethod());
          }
          setOrderId(null);
          setOpen(false);
        })
        .catch((error) => {
          if (!error.response.data.message) {
            toast.error(error.message, { position: 'top-right' });
          } else {
            toast.error(error.response.data.message, { position: 'top-right' });
          }
        });
    }
  };

  const handeleRestore = async () => {
    await CustomProductOrdersService.restore(orderId)
      .then((res) => {
        console.warn('--------', res);
        toast.success(res?.data?.message);
        if (requestName === 'All') {
          dispatch(getCustomProductOrderMethod());
        } else if (requestName === 'Pending') {
          dispatch(getCustomProductOrderPendingMethod());
        } else if (requestName === 'Confirm') {
          dispatch(getCustomProductOrderConfirmMethod());
        } else if (requestName === 'Completed') {
          dispatch(getCustomProductOrderCompleteMethod());
        } else if (requestName === 'Cancelled') {
          dispatch(getCustomProductOrderCancelledMethod());
        } else if (requestName === 'Deliver') {
          dispatch(getCustomProductOrderDeliverMethod());
        } else if (requestName === 'Deleted') {
          dispatch(getDeletedCustomProductOrderMethod());
        }
        setOrderId(null);
        setSelectStatus('Change Status');
        setOpen(false);
      })
      .catch((error) => {
        if (!error.response.data.message) {
          toast.error(error.message, { position: 'top-right' });
        } else {
          toast.error(error.response.data.message, { position: 'top-right' });
        }
      });
  };

  const handleChangeStatus = async (e) => {
    if (e.target.value === 'Confirm') {
      setorderStatus(e.target.value);
      handleDelivery();
      return;
    }
    const data = {
      status: e.target.value,
    };
    await CustomProductOrdersService.updateStatus(orderId, data)
      .then((res) => {
        console.warn('--------', res);
        toast.success(res?.data?.message);
        if (requestName === 'All') {
          dispatch(getCustomProductOrderMethod());
        } else if (requestName === 'Pending') {
          dispatch(getCustomProductOrderPendingMethod());
        } else if (requestName === 'Confirm') {
          dispatch(getCustomProductOrderConfirmMethod());
        } else if (requestName === 'Completed') {
          dispatch(getCustomProductOrderCompleteMethod());
        } else if (requestName === 'Cancelled') {
          dispatch(getCustomProductOrderCancelledMethod());
        } else if (requestName === 'Deliver') {
          dispatch(getCustomProductOrderDeliverMethod());
        }
        handleCloseChangeStatusMenu();
        setOrderId(null);
      })
      .catch((error) => {
        if (!error.response.data.message) {
          toast.error(error.message, { position: 'top-right' });
        } else {
          toast.error(error.response.data.message, { position: 'top-right' });
        }
        throw error;
      });
  };

  const handleChangeShippingFeeStatus = async (shippFee) => {
    const data = {
      status: orderStatus,
      total_shipping_fee: Number(shippFee),
    };
    await CustomProductOrdersService.updateStatus(orderId, data)
      .then((res) => {
        console.warn('--------', res);
        toast.success(res?.data?.message);
        if (requestName === 'All') {
          dispatch(getCustomProductOrderMethod());
        } else if (requestName === 'Pending') {
          dispatch(getCustomProductOrderPendingMethod());
        } else if (requestName === 'Confirm') {
          dispatch(getCustomProductOrderConfirmMethod());
        } else if (requestName === 'Completed') {
          dispatch(getCustomProductOrderCompleteMethod());
        } else if (requestName === 'Cancelled') {
          dispatch(getCustomProductOrderCancelledMethod());
        } else if (requestName === 'Deliver') {
          dispatch(getCustomProductOrderDeliverMethod());
        }
        handleCloseChangeStatusMenu();
        handleDelivery();
        setorderStatus(null);
        setOrderId(null);
      })
      .catch((error) => {
        if (!error.response.data.message) {
          toast.error(error.message, { position: 'top-right' });
        } else {
          toast.error(error.response.data.message, { position: 'top-right' });
        }
        throw error;
      });
  };

  console.log(filteredUsers);
  return (
    <>
      <Helmet>
        <title>Custom Product Orders | PakPrint Wishes </title>
      </Helmet>

      <Container maxWidth="xl">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            {requestName} Custom Product Orders
          </Typography>
          <Box>
            <Button
              variant="contained"
              sx={{ margin: '5px' }}
              onClick={() => {
                setRequestName('All');
                dispatch(getCustomProductOrderMethod());
              }}
            >
              All Orders
            </Button>
            <Button
              variant="contained"
              sx={{ margin: '5px' }}
              onClick={() => {
                setRequestName('Pending');
                dispatch(getCustomProductOrderPendingMethod());
              }}
            >
              Pending Orders
            </Button>
            <Button
              variant="contained"
              sx={{ margin: '5px' }}
              onClick={() => {
                setRequestName('Confirm');
                dispatch(getCustomProductOrderConfirmMethod());
              }}
            >
              Confirm Orders
            </Button>
            <Button
              variant="contained"
              sx={{ margin: '5px' }}
              onClick={() => {
                setRequestName('Deliver');
                dispatch(getCustomProductOrderDeliverMethod());
              }}
            >
              Deliver Orders
            </Button>
            <Button
              variant="contained"
              sx={{ margin: '5px' }}
              onClick={() => {
                setRequestName('Completed');
                dispatch(getCustomProductOrderCompleteMethod());
              }}
            >
              Complete Orders
            </Button>
            <Button
              variant="contained"
              sx={{ margin: '5px' }}
              onClick={() => {
                setRequestName('Cancelled');
                dispatch(getCustomProductOrderCancelledMethod());
              }}
            >
              Cancelled Orders
            </Button>
            <Button
              sx={{ margin: '5px' }}
              variant="contained"
              onClick={() => {
                setRequestName('Deleted');
                dispatch(getDeletedCustomProductOrderMethod());
              }}
            >
              Deleted Orders
            </Button>
          </Box>
        </Stack>

        <Card>
          <UserListToolbar numSelected={0} filterName={filterName} onFilterName={handleFilterByName} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <OrderProductListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  numSelected={0}
                  onRequestSort={handleRequestSort}
                />
                <TableBody>
                  {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    const { _id } = row;

                    return (
                      <TableRow hover key={_id}>
                        <TableCell component="th" scope="row">
                          <Typography variant="subtitle2" noWrap>
                            {!row?.name ? 'N/A' : row?.name}
                          </Typography>
                        </TableCell>

                        <TableCell align="left">{!row?.phone ? 'N/A' : row?.phone}</TableCell>
                        <TableCell align="left">{!row?.delivery_address ? 'N/A' : row?.delivery_address}</TableCell>
                        <TableCell align="left">{!row?.customQuantity ? 'N/A' : row?.customQuantity}</TableCell>
                        <TableCell align="left">{!row?.customTotal ? 'N/A' : row?.customTotal}</TableCell>
                        <TableCell align="left">{!row?.total_shipping_fee ? 'N/A' : row?.total_shipping_fee}</TableCell>
                        <TableCell align="left">{!row?.payment_method ? 'N/A' : row?.payment_method}</TableCell>
                        <TableCell align="left">
                          {!row?.createdAt ? 'N/A' : new Date(row?.createdAt).toISOString().substring(0, 10)}
                        </TableCell>
                        <TableCell align="left">{!row?.status ? 'N/A' : row?.status}</TableCell>
                        <TableCell align="left">
                          <Button
                            disabled={requestName === 'Deleted'}
                            onClick={(e) => {
                              handleOpenChangeStatusMenu(e, _id);
                            }}
                          >
                            Change Status
                          </Button>
                        </TableCell>
                        <TableCell align="right">
                          <IconButton
                            size="large"
                            color="inherit"
                            onClick={(e) => {
                              handleOpenMenu(e, row);
                            }}
                          >
                            <Iconify icon={'eva:more-vertical-fill'} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            Not found
                          </Typography>

                          <Typography variant="body2">
                            No results found for &nbsp;
                            <strong>&quot;{filterName}&quot;</strong>.
                            <br /> Try checking for typos or using complete words.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredUsers.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
      <DeliveryChargesDialog
        open={deliveryDiloag}
        handleClose={handleDelivery}
        handleChangeShippingFeeStatus={handleChangeShippingFeeStatus}
      />
      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        {requestName !== 'Deleted' ? (
          <Link
            style={{ color: 'black', textDecoration: 'none' }}
            to={`/dashboard/custom-product-orders/custom-product-order-products/${orderId}`}
            state={{ item: orderItem }}
          >
            <MenuItem>
              <Iconify icon={'ic:outline-remove-red-eye'} sx={{ mr: 2 }} />
              View
            </MenuItem>
          </Link>
        ) : null}
        {requestName === 'Deleted' ? (
          <MenuItem onClick={handeleRestore}>
            <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
            Restore
          </MenuItem>
        ) : null}
        <MenuItem sx={{ color: 'error.main' }} onClick={handleDeleteMethod}>
          <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Popover>
      <Popover
        open={Boolean(changeStatusMenu)}
        anchorEl={changeStatusMenu}
        onClose={handleCloseChangeStatusMenu}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 200,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <FormControl fullWidth>
          <Select value={selectStatus} onChange={handleChangeStatus} sx={{ textAlign: 'left' }}>
            <MenuItem value="Change Status" disabled>
              Change Status
            </MenuItem>
            <MenuItem value="Pending">Pending</MenuItem>
            <MenuItem value="Confirm">Confirm</MenuItem>
            <MenuItem value="Deliver">Deliver</MenuItem>
            <MenuItem value="Completed">Completed</MenuItem>
            <MenuItem value="Cancelled">Cancelled</MenuItem>
          </Select>
        </FormControl>
      </Popover>
    </>
  );
}
